import { useContext } from 'react';

import {NotesContext } from './NotesContext';

const useNotesContext = () => {
  const context = useContext(NotesContext);
  if (!context) {
    throw new Error('NotesContext must be a child of MainProvider');
  }
  return { ...useContext(NotesContext) };
};
export default useNotesContext;
